__turbopack_context__.v({
  "container": "fab-menu-module-scss-module__KOtada__container",
  "container__item": "fab-menu-module-scss-module__KOtada__container__item",
  "container__item__clicked": "fab-menu-module-scss-module__KOtada__container__item__clicked",
  "container__item__not-clicked": "fab-menu-module-scss-module__KOtada__container__item__not-clicked",
  "fake-element": "fab-menu-module-scss-module__KOtada__fake-element",
  "layout": "fab-menu-module-scss-module__KOtada__layout",
});
